import React from 'react';
import { connect } from 'react-redux';

import SalonModal from 'components/dialog/SalonModal.component';
import Button from 'components/form/Button.component';
import Icon from 'components/generic/Icon.component';
import IconStatus from 'components/generic/IconStatus.component';
import CurrencySign from 'components/price/CurrencySign.component';
import { useTranslation } from 'providers/GILT.provider';
import { selectCurrentSalonPricingPlan } from 'selectors/currentSalon.selectors';

import CN from './EssentialOrAdvancedModal.module.scss';

const EssentialOrAdvancedModal = ({ isOpen, onClose, pricePerStylist, pricingPlan }) => {
  const { t } = useTranslation();

  return (
    <SalonModal tag="EssentialOrAdvancedModal" isOpen={isOpen} variant="noFooter">
      <SalonModal.Header>
        <div className={CN.closeButtonContainer}>
          <Button variant="empty" onClick={onClose}>
            <Icon variant="close" variantInvert />
          </Button>
        </div>
      </SalonModal.Header>
      <SalonModal.Body>
        <IconStatus width="lg" variant="success">
          <Icon selected width="l1" variant="confirm" />
        </IconStatus>

        <div className={CN.modalContent}>
          <div className={CN.modalTitle}>{t('stylistScreen.essentialOrAdvancedModal.title')}</div>
          <div className={CN.modalText}>
            {t('stylistScreen.essentialOrAdvancedModal.descriptionPart1', { plan: pricingPlan })}
            <div className={CN.highlighted}>
              {/* TODO: localisation price + tax */}
              <CurrencySign value={pricePerStylist} /> {t('stylistScreen.essentialOrAdvancedModal.descriptionPart2')}
            </div>
          </div>
        </div>
      </SalonModal.Body>
    </SalonModal>
  );
};

const mapStateToProps = (state) => ({
  pricingPlan: selectCurrentSalonPricingPlan(state),
});

const EssentialOrAdvancedModalHoc = connect(mapStateToProps)(EssentialOrAdvancedModal);

export default EssentialOrAdvancedModalHoc;
